import { useMemo } from 'react';
import useMe from './useMe';
import { DEFAULT_PERMISSIONS_LIST } from '../constants/permissionsList';
import usePermissionStatus from './useHasPermission';

function usePermissionStatusByKey(
  permissionKey,
  type = DEFAULT_PERMISSIONS_LIST,
) {
  const { getPermissionStatus } = usePermissionStatus(type);
  const { data: currentUser } = useMe();

  return useMemo(() => {
    return currentUser?.role === 'Admin'
      ? true
      : getPermissionStatus(permissionKey);
  }, [currentUser?.role, getPermissionStatus, permissionKey]);
}

export default usePermissionStatusByKey;
